<pep-message-dialog [title]="'Upload Status'"
  [showCancelButton]="false"
  [acceptButtonText]=""
  (pushAccept)="closeDialog()"
  (pushCancel)="closeDialog()"
  (pushClose)="closeDialog()">
  <div class="content">
    <div class="actions">
      <button mat-icon-button (click)="updateData()" class="btn btn-outline-primary renew"
        ngbTooltip="Ansicht aktualisieren" container="body" tooltipClass="myTooltip" triggers="hover">
        <mat-icon>autorenew</mat-icon>
      </button>
      <button mat-icon-button (click)="closeDialog()" class="btn btn-outline-primary renew"
        ngbTooltip="Dialog schließen" container="body" tooltipClass="myTooltip" triggers="hover">
        <mat-icon>close</mat-icon>
      </button>
    </div>

    <div [class.flex]="fileUploadDetails?.length">
      <div class="left-content">
        <div class="form-group has-search inputField">
          <input [(ngModel)]="searchTerm" (ngModelChange)="search()" class="form-control form-control-search" placeholder="Suche"
            style="height: 38px;" />
          </div>

          <table mat-table [dataSource]="tabledata" class="table" multiTemplateDataRow
            matSort matSortDisableClear [trackBy]="trackByIndex">

            <ng-container matColumnDef="date" sticky>
              <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Zeitstempel</th>
              <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
                <span>{{data?.uploadTimestamp ? (data.uploadTimestamp | date:'dd.MM.yyyy HH:mm:ss') : ""}}</span>
              </td>
            </ng-container>

            <ng-container matColumnDef="fileType" sticky>
              <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Dateityp</th>
              <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
                @if (data.fileType == 0) {
                  <span>Zertifikat</span>
                }
                @if (data.fileType == 1) {
                  <span>Setupdatei</span>
                }
                @if (data.fileType == 2) {
                  <span>Firmware</span>
                }
              </td>
            </ng-container>

            <ng-container matColumnDef="fileName" sticky>
              <th mat-header-cell *matHeaderCellDef style="padding-left: 24px !important;" mat-sort-header>Dateiname</th>
              <td mat-cell *matCellDef="let data; let i = index" class="paddingLeft">
                <span>{{data.fileName}}</span>
              </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky:true"></tr>
            <tr mat-row *matRowDef="let data; columns: displayedColumns;" class="highlight clickable"
              [class.active]="isActive(data)"
            (click)="openDetails(data, $event)"></tr>

          </table>
        </div>
        <div class="right-content">
          <div class="line"></div>
          <upload-protocol-details [data]="fileUploadDetails"></upload-protocol-details>
        </div>
      </div>

    </div>
  </pep-message-dialog>
